<div class="row" *ngIf="!showFallbackView">
  <div class="col-sm-12">
    <div class="d-flex flex-row post-header">
      <div class="post-summarize">
        <div *ngIf="showIndexNumber" class="d-flex flex-row">
          <div class="col-index-header">#</div>
          <div class="influencer-exposure-header">{{'INFLUENCER.insight.best_performing_exposure.title' | translate}}</div>
        </div>
      </div>
      <div class="post-kpi header-title">
        <div class="d-flex flex-row flex-auto mb-2">
          <div class="platform-col">
          </div>
          <div class="impression-col">
            <span class="best-performing-header impressions" title="{{'INFLUENCER.insight.best_performing_exposure.engagement' | translate}}">{{'INFLUENCER.insight.best_performing_exposure.engagement' | translate}}</span>
          </div>
          <div class="reach-col">
            <span class="best-performing-header reach" title="{{'INFLUENCER.insight.best_performing_exposure.reach' | translate}}">{{'INFLUENCER.insight.best_performing_exposure.reach' | translate}}</span>
          </div>
          <div class="impact-col">
            <span class="best-performing-header impact" title="{{'INFLUENCER.insight.best_performing_exposure.impact' | translate}}">{{'INFLUENCER.insight.best_performing_exposure.impact' | translate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12"
       *ngFor="let bestExposure of bestPerformingExposures; let i = index; let lastRow = last">
    <div class="best-performing-row" [ngClass]="{'even': i % 2 === 0, 'odd' : i % 2 !== 0, 'customized-border-radius': lastRow}">
      <best-performing-exposure-item *ngIf="showIndexNumber" [bestPerformingExposure]="bestExposure" [index]="i+1"></best-performing-exposure-item>
      <best-performing-exposure-item *ngIf="!showIndexNumber" [bestPerformingExposure]="bestExposure"></best-performing-exposure-item>
    </div>
  </div>
</div>
<div *ngIf="showFallbackView" class="full-width">
  <best-performing-exposure-placeholder></best-performing-exposure-placeholder>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-exposure/best-performing-exposure.component.html